var isType = require('./is-type');

var isDate = function isDate(value) {
  return isType(value, 'Date');
};

module.exports = isDate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/type/is-date.js
// module id = 239
// module chunks = 0